import { InUseStatus } from '#/graphql/types';
import EnumMapping from '#/types/EnumMappings';

export const inUseStatuses: EnumMapping<InUseStatus> = {
  newlyCreated: {
    key: 'newlyCreated',
    label: 'Newly Created',
  },
  inUse: {
    key: 'inUse',
    label: 'In-use',
  },
  deprecated: {
    key: 'deprecated',
    label: 'Deprecated',
  },
};

export const levels = [
  { key: 'country', label: 'Country' },
  { key: 'state', label: 'State' },
  { key: 'city', label: 'City' },
  { key: 'building', label: 'Building' },
];
